module.exports = __webpack_public_path__ + "img/reports_active.da9eafd2.svg";